import React, {useEffect, useState, useContext} from "react";
import {useTranslation} from "react-i18next";
import {Button} from "@material-ui/core";
import CaptureArea from "../../Ocr/CaptureTextFromImage/CaptureArea";
import {getExtension} from "../../../../helpers/helper";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import {activeAutom} from "../../../../recoil-store/recoil-state";
import {useRecoilState} from 'recoil';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @param       action
 * @param       variables
 * @param       setOpenVariable
 * @param       variableRender
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function FileAndInput({
                          action,
                          variables,
                          setOpenVariable,
                          variableRender,
                          actions,
                      }) {
    const [imgCoordinate, setImgCoordinate] = useState({coordinates: []});
    const [openCaptureArea, setOpenCaptureArea] = useState(false);
    const [fileName, setFileName] = useState("");
    const [upImg, setUpImg] = useState();
    const [value, setValue] = useState(0);
    const [cropImg, setCropImg] = useState("");
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);
    let clickDiv = null;
    const {t} = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.FIND-AND-CLICK.";
    function findScopeAction(nodes, mainNodes) {
        for (let node of nodes) {
            if ('children' in node) {
                findScopeAction(node.children, node);
            } else if (node.id === action.id) {
                if (mainNodes?.fields?.getSS || actions[mainNodes?.id]?.fields?.getSS) {
                    let getSSURL = actions[mainNodes?.id]?.fields?.getSS?.value?.length ? actions[mainNodes.id].fields.getSS.value : mainNodes.fields.getSS?.value
                    setUpImg(getSSURL);
                    if (
                        (action.fields.destination.value.x === 0 &&
                            action.fields.destination.value.y === 0)
                    ) {
                        action.fields.destination = {value: {x: 0, y: 0}};
                        action.fields.source = {value: {x: 0, y: 0}};
                        setImgCoordinate({coordinates: []});
                    }
                }
            }
        }
    }
    useEffect(() => {
        if (!action.fields.imgURL) {
            action.fields.imgURL = {value: ""};
        } else {
            setUpImg(action.fields.imgURL.value);
        }
        if (!action.fields.completedCrop) {
            action.fields.completedCrop = {value: []};
        } else {
            setImgCoordinate({coordinates: action.fields.completedCrop.value});
        }
        if (!action.fields.fileName) {
            action.fields.fileName = {value: ""};
        } else {
            setFileName(action.fields.fileName.value);
        }
        if (!action.fields.mediaSize) {
            action.fields.mediaSize = {value: {width: 0, height: 0, div: 0}};
        }
        if (!action.fields.gridCrop) {
            action.fields.gridCrop = {value: []};
        }
        if (!action.fields.destination) {
            action.fields.destination = {value: {x: 0, y: 0}};
        }
        if (!action.fields.source) {
            action.fields.source = {value: {width: 0, height: 0, x: 0, y: 0, id: "asdf"}};
        }
        if (!action.fields.difference) {
            action.fields.difference = {value: ""};
        }
        if (!action.fields.cropImg) {
            action.fields.cropImg = {value: ""};
        } else {
            setCropImg(action.fields.cropImg.value);
        }
        let items = JSON.parse(JSON.stringify(automDetail.items))
        findScopeAction(items);
    }, [action, variables, variableRender]);
    function resizeImage(url, width, height, x, y, arr) {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const imageObj = new Image();
        // set canvas dimensions
        canvas.width = width;
        canvas.height = height;
        imageObj.onload = function () {
            context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);
            setCropImg(canvas.toDataURL());
        };
        imageObj.src = url;
    }
    //convert base64 to buffer byte array
    useEffect(() => {
        resizeImage(
            upImg,
            action.fields.source.value.width,
            action.fields.source.value.height,
            action.fields.source.value.x,
            action.fields.source.value.y
        );
        if (upImg) {
            action.fields.cropImg = {
                byteValue: cropImg,
                value: fileName,
                extension: getExtension(fileName),
                type: "FILE",
            };
        }
    }, [
        action.fields,
        upImg,
        setOpenCaptureArea,
        openCaptureArea,
        cropImg,
        setCropImg,
    ]);
    return (
        <>
            <div className="form-element">
                <div>
                    <Button
                        variant="outlined"
                        onClick={() => setOpenCaptureArea(true)}
                        style={{
                            background: "#031226",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)",
                            borderRadius: 4,
                            color: "#fff",
                            fontWeight: 700,
                        }}
                    >
                        {t(label + "INITIATE-SELECTOR")}
                    </Button>
                </div>
                {openCaptureArea && (
                    <CaptureArea
                        imgCoordinate={{coordinates: action.fields.completedCrop.value}}
                        setImgCoordinate={setImgCoordinate}
                        action={action}
                        upImg={upImg}
                        setOpenCaptureArea={setOpenCaptureArea}
                        setOpenVariable={setOpenVariable}
                        variables={variables}
                        isGrid={value}
                        isVariableShow={false}
                        clickDiv={clickDiv}
                        isFindAndInput={true}
                    />
                )}
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.ASSIGN')}
                <VariablePicker
                    action={action}
                    inputName="set"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    filter="boolean"
                />
            </div>
        </>
    );
}
export default FileAndInput;